/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const TroubleShootingTools32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlGray80}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 19c-1 1.5-1 2.333-1 3h-6c0-.5 0-1.5-1-3-.236-.354-.528-.708-.836-1.082C10.167 16.708 9 15.292 9 13c0-3 2-7 7-7s7 4 7 7c0 2.345-1.353 3.97-2.32 5.13-.27.325-.509.613-.68.87zm-6.3-5.79l-.7.677L14.952 16 19 11.682 18.304 11l-3.347 3.57-1.256-1.36z"
            fill="#fff"
        />
        <path d="M13 24v-1h6v1h-6zm1.268 1a2 2 0 003.464 0h-3.464z" fill="#fff" />
    </AccessibleSVG>
);

export default TroubleShootingTools32;
